export default __webpack_public_path__ + "static/media/close.ff8e7b9c.svg";